<template>
  <div class="content" :style="individuationBg?{backgroundImage:'url('+individuationBg+')'}:{}">
    <seach-wrap :viewType='viewType' :enableChange='enableChage' :queryCode="queryCode" @query='queryHandle'
                @queryInput="handleInput"></seach-wrap>
    <search-state v-if="searchState" :state="searchState" @reSearch="resetState"></search-state>
  </div>
</template>

<script>
  import seachWrap from './searchWrap.vue'
  import enums from '../../enums/index.js'
  import searchState from './searchState.vue'
  import utils from '../../utils/index.js'
  import envConfig from '../../config/env.js'
  import { mapGetters } from 'vuex'
  import bgIndexPath from '../../../static/bg-index.jpg';

  const currentPlatform = utils.getPlatform() ? enums.ANDROIDPC : enums.PC;
  // url 分析，得到code，configcode，maccode
  // 如果有code，则给input赋值
  // 有configcode则请求个性化配置
  // created时绑定maccode与configcode
  let VMObject = null;
  let querying = false;
  window.initPageByCode = function (code) {
    if (querying) {
      return;
    }
    if (VMObject && code) {
      querying = true;
      VMObject.queryCode = code;
      VMObject.queryHandle(code);
      setTimeout(() => {
        querying = false;
        VMObject.queryCode = '';
      }, 1000);
    }
  }
  const locationManager = {
    clear(itemName = []) {
      itemName.forEach((itemName) => {
        itemName ? localStorage.removeItem(itemName) : null;
      });
    }
  };
  //
  const search = utils.getSearch();
  const { from = '' } = search;
  const isWindowsAio = from.toLocaleUpperCase() === 'windowsAio'.toLocaleUpperCase();
  //
  export default {
    data() {
      return {
        otherAjaxReady: false,
        logo: '',
        searchState: 0,
        allAjaxSuccess: [0, 0, 0, 0, 0, 0],
        queryCode: '',
        configCode: '',
        macCode: '',
        viewType: currentPlatform,
        enableChage: currentPlatform == enums.ANDROIDPC,
        windowsAioSearchTimeout: null
      }
    },
    computed: {
      ...mapGetters(['individuationBg'])
    },
    watch: {
      allAjaxSuccess: function (val) {
        if (val.some((v) => v)) {
          if (val[0] ^ val[1]) {
            querying = false;
            VMObject.queryCode = '';
            return
          }
          if (val[2] ^ val[3]) {
            querying = false;
            VMObject.queryCode = '';
            return
          }
          if (val[4] ^ val[5]) {
            querying = false;
            VMObject.queryCode = '';
            return
          }
          if (val[5] ^ val[6]) {
            querying = false;
            VMObject.queryCode = '';
            return
          }
          if (!this.otherAjaxReady) {
            return;
          }
        }
        if (this.searchState) {
          if (this.showResult && (this.showResult != 'false')) {
            this.$router.replace({ 'path': '/index' });
          } else {
            this.$router.push({ 'path': '/index' });
          }
        }
      },
      queryCode: function () {
        console.log(this.queryCode);
      }
    },
    methods: {
      async isPackCodeCheck(code) {
        this.searchState = enums.ajaxState.working;
        let result = false;
        try {
          const res = await this.$ajax.cacheJsonp(this.$urlAPI.BaseData.PackCodeQueryCheck, { code });
          if (res.Result == 200 && res.Data.IsPackPanentCode) {
            result = true;
          }
        } catch (err) {
          console.error(err);
        }
        return result;
      },
      async queryHandle(code = '') {
        code = this.queryCode;
        const isPackCode = await this.isPackCodeCheck(code);
        if (isPackCode) {
          localStorage.setItem('packCode', code);
          if (this.showResult && (this.showResult != 'false')) {
            this.$router.replace({ 'path': '/pack' });
          } else {
            this.$router.push({ 'path': '/pack' });
          }
        } else {
          if (Date.now() - this.createTime < 2000) {
            code && this.queryCode && this.getTraceQueryResult(code);
            return;
          }
          this.getTraceQueryResult(code);
        }
      },
      resetState() {
        this.queryCode = '';
        this.searchState = 0;
        this.allAjaxSuccess = [0, 0, 0, 0, 0, 0, 0];
      },
      getTraceQueryResult(code = '') {
        if (!window.navigator.onLine) {
          this.searchState = enums.ajaxState.badnetwork;
          return;
        }
        code = this.queryCode;
        this.searchState = enums.ajaxState.working;
        querying = false;
        VMObject.queryCode = '';
        locationManager.clear(['resultData', 'ProductName', 'geoInfo', 'otherTestData', 'plotsData', 'resultCustomFunctionData', 'resultWeatherData', 'selfTestData', 'traceingBatchID', 'traceDataSave']);
        this.$hideKeyboard();
        if (code.length === 6) {
          utils.getIndividuation(code, this.macCode).then((response) => {
            if (response && response.QueryPageConfiguration && response.QueryPageConfiguration.QueryPageConfigurationCode) {
              this.configCode = response.QueryPageConfiguration.QueryPageConfigurationCode;
              this.searchState = enums.ajaxState.pageConfigSuccess;
              utils.setIndividuation(this, response);
            } else {
              this.searchState = enums.ajaxState.failed
            }
          });
          return;
        }
        if (code.length > 0) {
          this.$ajax.jsonp(this.$urlAPI.BaseData.TraceQuery, { QueryType: 1, Code: code }).then((result) => {
            this.loadData(result, code);
            if (code.length == 17) {
              if (result && result.Result == 1 && result.Data) {
              }
            }
          }, () => {
            this.searchState = enums.ajaxState.failed
          });
        } else {
          this.searchState = enums.ajaxState.failed
          debugger
        }
      },
      getQueryResult(id) {
        if (!id && id.length < 1) {
          return;
        }
        this.$ajax.jsonp(this.$urlAPI.BaseData.GetAntiFakeQueryResult, { ResultID: id }).then((result) => {
          this.loadData(result);
        }, () => {
          this.searchState = enums.ajaxState.failed
        });
      },
      getWeatherInfo(lng = '', lat = '') {
        this.allAjaxSuccess.splice(0, 1, 1);
        this.$ajax.cacheJsonp(this.$urlAPI.BaseData.GetWeatherInfo, {
          Longitude: lng,
          Latitude: lat
        }).then((result) => {
          localStorage.setItem('resultWeatherData', JSON.stringify(result));
          this.allAjaxSuccess.splice(1, 1, 1);
        }, () => {
          this.searchState = enums.ajaxState.failed
        });
      },
      getLngLat(result) {
        const ProductBatchID = result.Data.ProductBatchID;
        return new Promise(resolve => {
          this.$ajax.jsonp(this.$urlAPI.BaseData.GetWeatherStationListByProductBatchID, { ProductBatchID }).then(res => {
            const record = res.Data.RecordList ? res.Data.RecordList[0] : null;
            if (record) {
              resolve({ lng: record.Longitude, lat: record.Latitude });
            } else {
              resolve(null);
            }
          });
        });
      },
      async loadData(result, code) {
        if (result.Error) {
          this.searchState = enums.ajaxState.failed
          return;
        }
        const resultData = result.Data || {};
        if (resultData.MicroPage && resultData.MicroPage.MicroPageID) {
          if (this.enableChage) {
            this.searchState = enums.ajaxState.noajax;
            this.$changeWebViewByURL(envConfig.microPageBaseUrl + '?PageID=' + resultData.MicroPage.MicroPageID);
          } else {
            this.searchState = enums.ajaxState.success;
            location.href = envConfig.microPageBaseUrl + '?PageID=' + resultData.MicroPage.MicroPageID
          }
          return;
        }
        if (resultData.BatchData) {
          if (resultData.TraceCheckStatus == 1) {
            if (resultData.ProductBatchID != '') {
              this.allAjaxSuccess.splice(2, 1, 1);
              this.$ajax.jsonp(this.$urlAPI.BaseData.ProductBatchCustomFunction, { BatchID: resultData.ProductBatchID }).then((result) => {
                if (result.Data.Rows.length > 0) {
                  localStorage.setItem('resultCustomFunctionData', JSON.stringify(result.Data.Rows));
                }
                this.allAjaxSuccess.splice(3, 1, 1);
              }, () => {
                this.searchState = enums.ajaxState.failed
              });
            }
          }
        }
        if (resultData.TraceNodes && resultData.TraceNodes.length > 0) {
          for (var i = 0; i < result.Data.TraceNodes.length; i++) {
            var node = result.Data.TraceNodes[i];
            if (node.TraceNodeType == 2) {
              var content = (0, eval)('(' + node.TraceNodeContent + ')');
              this.getWeatherInfo(content.Longitude, content.Latitude);
              localStorage.setItem('geoInfo', JSON.stringify(content));
            }
          }
        } else {
          this.getLngLat(result).then(lnglat => {
            if (lnglat) {
              this.getWeatherInfo(lnglat.lng, lnglat.lat);
            }
          });
        }
        this.allAjaxSuccess.splice(4, 1, 1);
        this.allAjaxSuccess.splice(5, 1, 1);
        localStorage.setItem('resultData', JSON.stringify(resultData));
        localStorage.setItem('ProductName', resultData.ProductName);
        this.$ajax.cacheJsonp(this.$urlAPI.BaseData.GetBlockchain, { ProductBatchID: resultData.ProductBatchID }).then((res) => {
          localStorage.setItem('blockchain', JSON.stringify(res));
          this.$sleep(200);
          this.allAjaxSuccess.splice(6, 1, 1);
        }, () => {
          this.searchState = enums.ajaxState.failed
        });
        try {
          const r = await this.$ajax.cacheJsonp(this.$urlAPI.BaseData.GetBlockchainList, { ProductBatchID: resultData.ProductBatchID });
          if (r.Result == 200 && r.Data) {
            localStorage.setItem('blockchainList', JSON.stringify(r));
          } else {
            localStorage.setItem('blockchainList', JSON.stringify(r));
          }
          const r2 = await this.$ajax.cacheJsonp(this.$urlAPI.BaseData.GetStampList, { ProductBatchID: resultData.ProductBatchID });
          if (r2.Result == 200 && r2.Data) {
            localStorage.setItem('timeStamp', JSON.stringify(r2));
          } else {
            localStorage.setItem('timeStamp', JSON.stringify(r2));
          }
        } catch (err) {
          console.error(err);
        }
        this.otherAjaxReady = true;
        this.allAjaxSuccess = [].concat(this.allAjaxSuccess);
      },
      handleInput(code) {
        this.queryCode = code;
        if (isWindowsAio) {
          const numCode = this.getNumbers(code);
          if (numCode) {
            this.queryCode = numCode;
            this.windowsAioSearch(numCode);
          }
        }
      },
      windowsAioSearch(code) {
        clearTimeout(this.windowsAioSearchTimeout);
        this.windowsAioSearchTimeout = setTimeout(() => {
          window.initPageByCode(code);
        }, 500);
      },
      getNumbers(code) { //获取连续10位以上的数字
        const result = code.match(/\d{10,}/);
        if (result && result[0]) {
          return result[0];
        }
        return '';
      }
    },
    components: {
      seachWrap,
      searchState
    },
    created() {
      this.createTime = Date.now();
      this.$changeScanState(this.enableChage);
    },
    beforeRouteEnter(to, from, next) {
      const code = to.query.code || utils.URLSearchCodes.code || '';
      const configcode = to.query.configcode || utils.URLSearchCodes.configcode || null;
      const maccode = to.query.maccode || utils.URLSearchCodes.maccode || '';
      const showResult = to.query.showresult || utils.URLSearchCodes.showresult || '';
      if (showResult) {
        next((vm) => {
          vm.queryCode = code;
          vm.configCode = configcode;
          vm.macCode = maccode;
          vm.showResult = showResult;
          VMObject = vm;
          vm.queryHandle(code);
        })
        return;
      }
      utils.getIndividuation(configcode, maccode).then((response) => {
        next((vm) => {
          vm.queryCode = code;
          vm.configCode = configcode;
          vm.macCode = maccode;
          VMObject = vm;
          document.getElementById('app').style.backgroundImage = 'none';
          utils.setIndividuation(vm, response);
        });
      });
    },
    beforeRouteLeave(to, from, next) {
      // this.$changeScanState(false);
      document.getElementById('app').style.backgroundImage = 'url(' + bgIndexPath + ')';
      this.$el.parentNode.style.backgroundImage = 'none'
      next();
    }
  }
</script>
<style lang="less" scoped>
  @import '../../assets/less/base.less';

  .content {
    height: 100%;
    background: #0f2c56 center center no-repeat;
    background-size: cover;
    .searchContentBg;
  }
</style>



// WEBPACK FOOTER //
// index.vue?704af536